// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vault_member_sync_mode.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file vault_member_sync_mode.proto.
 */
export const file_vault_member_sync_mode: GenFile = /*@__PURE__*/
  fileDesc("Chx2YXVsdF9tZW1iZXJfc3luY19tb2RlLnByb3RvEgZkb21haW4qwQEKE1ZhdWx0TWVtYmVyU3luY01vZGUSHwobVkFVTFRfTUVNQkVSX1NZTkNfTU9ERV9OT05FEAASNAowVkFVTFRfTUVNQkVSX1NZTkNfTU9ERV9BTExfT1JHQU5JWkFUSU9OX1BST0ZJTEVTEAESLworVkFVTFRfTUVNQkVSX1NZTkNfTU9ERV9BTExfREVMRUdBVEVEX0FETUlOUxACEiIKHlZBVUxUX01FTUJFUl9TWU5DX01PREVfQkFDS0VORBADQjBaLmdpdGxhYi5jb20vY290ZWNoZGUvbW9ub3JlcG8vYmFja2VuZC9kb21haW4vcGJiBnByb3RvMw");

/**
 * @generated from enum domain.VaultMemberSyncMode
 */
export enum VaultMemberSyncMode {
  /**
   * used as default value, see https://developers.google.com/protocol-buffers/docs/proto3#enum
   *
   * @generated from enum value: VAULT_MEMBER_SYNC_MODE_NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: VAULT_MEMBER_SYNC_MODE_ALL_ORGANIZATION_PROFILES = 1;
   */
  ALL_ORGANIZATION_PROFILES = 1,

  /**
   * @generated from enum value: VAULT_MEMBER_SYNC_MODE_ALL_DELEGATED_ADMINS = 2;
   */
  ALL_DELEGATED_ADMINS = 2,

  /**
   * @generated from enum value: VAULT_MEMBER_SYNC_MODE_BACKEND = 3;
   */
  BACKEND = 3,
}

/**
 * Describes the enum domain.VaultMemberSyncMode.
 */
export const VaultMemberSyncModeSchema: GenEnum<VaultMemberSyncMode> = /*@__PURE__*/
  enumDesc(file_vault_member_sync_mode, 0);

